import { type IConversions } from "./IConversions";

/*
 * A static conversion that looks up numbered ids in an array.
 *
 * This is used for lists that have their data available in the frontend as a simple static list.
 */
export class IndexedConversions<T> implements IConversions<number, T> {
	private items: T[];

	constructor(items: T[]) {
		this.items = items;
	}

	data(key: number): T {
		return this.items[key];
	}

	load() {
		return Promise.resolve();
	}

	invalidate(): Promise<void> {
		throw Error("an IndexedConversion cannot invalidate its entries, they are fixed at construction");
	}

	get isResetting(): number {
		return 0;
	}
}
